const CLIENT_ID_KEY = 'browserClientId';

const hasTelegramUser = () => {
  return Boolean(window.Telegram?.WebApp?.initDataUnsafe?.user?.id);
};

export const isTelegramEnvironment = () => {
  return hasTelegramUser();
};

export const getBrowserClientId = () => {
  let clientId = localStorage.getItem(CLIENT_ID_KEY);

  if (!clientId) {
    clientId = crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

    localStorage.setItem(CLIENT_ID_KEY, clientId);
  }

  return clientId;
};

export const getCurrentIdentity = async () => {
  if (hasTelegramUser()) {
    return {
      userId: window.Telegram.WebApp.initDataUnsafe.user.id,
      clientId: null,
      isTelegram: true,
      linked: true
    };
  }

  const clientId = getBrowserClientId();

  const response = await fetch('/api/browser/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientId })
  });

  const data = await response.json();

  if (data.clientId && data.clientId !== clientId) {
    localStorage.setItem(CLIENT_ID_KEY, data.clientId);
  }

  return {
    userId: data.userId,
    clientId: data.clientId || clientId,
    isTelegram: false,
    linked: Boolean(data.linked)
  };
};